// Mensagens pt-br: `ra.*` (react-admin) + namespaces próprios (`tooltips.*`).
// Texto de tela novo NÃO precisa de chave aqui: o próprio texto em português é a
// chave (ver `src/i18n/index.ts`). Aqui só entra o que já é chave nomeada.
const ptBr = {
    ra: {
        action: {
            select_all_button: 'Selecionar todos',
            add_filter: 'Adicionar filtro',
            add: 'Adicionar',
            back: 'Retornar',
            bulk_actions:
                '%{smart_count} selecionado |||| %{smart_count} selecionados',
            cancel: 'Cancelar',
            clear_array_input: 'Limpar lista',
            clear_input_value: 'Limpar valor',
            clone: 'Duplicar',
            confirm: 'Confirmar',
            create: 'Criar',
            create_item: 'Criar %{item}',
            delete: 'Remover',
            edit: 'Alterar',
            export: 'Exportar',
            list: 'Listar',
            refresh: 'Atualizar',
            remove_filter: 'Remover filtro',
            remove: 'Remover',
            remove_all_filters: 'Remover todos filtros',
            save: 'Salvar',
            search: 'Buscar',
            select_all: 'Selecionar todos',
            select_row: 'Selecionar linha',
            show: 'Mostrar',
            sort: 'Ordenar',
            undo: 'Desfazer',
            expand: 'Expandir',
            close: 'Fechar',
            open_menu: 'Abrir menu',
            close_menu: 'Fechar menu',
            unselect: 'Desmarcar',
            update: 'Atualizar',
            move_up: 'Mover pra cima',
            move_down: 'Mover pra baixo',
            open: 'Abrir',
            toggle_theme: 'Trocar modo light/dark',
            select_columns: 'Colunas',
            update_application: 'Recarregar Aplicação',
            reset: 'Restaurar',
            search_columns: 'Buscar colunas',
        },
        boolean: {
            true: 'Sim',
            false: 'Não',
            null: '',
        },
        page: {
            access_denied: 'Acesso negado',
            authentication_error: 'Erro de autenticação',
            create: 'Criar %{name}',
            dashboard: 'Dashboard',
            edit: '%{name} #%{id}',
            error: 'Ocorreu um problema',
            list: '%{name}',
            loading: 'Carregando',
            not_found: 'Não encontrado',
            show: '%{name} #%{id}',
            empty: 'Sem itens ainda.',
            invite: 'Você quer adicionar um?',
        },
        input: {
            file: {
                upload_several:
                    'Solte arquivos para upload, ou clique para selecionar um.',
                upload_single:
                    'Solte um arquivo para upload, ou clique para selecioná-lo.',
            },
            image: {
                upload_several:
                    'Solte imagens para upload, ou clique para selecionar uma.',
                upload_single:
                    'Solte uma imagem para upload, ou clique para selecioná-la.',
            },
            references: {
                all_missing:
                    'Não foi possível encontrar os dados de referência.',
                many_missing:
                    'Pelo menos uma das referências associadas aparenta não estar mais disponível.',
                single_missing:
                    'A referência associada aparenta não estar mais disponível.',
            },
            password: {
                toggle_visible: 'Ocultar senha',
                toggle_hidden: 'Mostrar senha',
            },
            autocomplete: {
                no_options_text: 'Nenhuma opção encontrada',
            },
        },
        message: {
            access_denied: 'Você não tem permissão de acessar essa página',
            authentication_error:
                'O servidor de autenticação retornou um erro e suas credenciais não puderam ser verificadas.',
            placeholder_data_warning: 'Problema de rede: falha na atualização de dados.',
            select_all_limit_reached:
                'Há muitos elementos para selecionar todos. Apenas os primeiros %{max} elementos foram selecionados.',
            about: 'Sobre',
            are_you_sure: 'Tem certeza?',
            auth_error:
                'Houve um erro com o token de autenticação.',
            bulk_delete_content:
                'Você tem certeza que quer remover isso %{name}? |||| Você tem certeza que quer remover estes %{smart_count} items?',
            bulk_delete_title:
                'Remover %{name} |||| Remover %{smart_count} %{name}',
            bulk_update_content:
                'Tem certeza que deseja atualizar %{name}? |||| Tem certeza que deseja atualizar estes %{smart_count} itens?',
            bulk_update_title:
                'Atualizar %{name} |||| Atualizar %{smart_count} %{name}',
            clear_array_input: 'Tem certeza que deseja limpar a lista inteira?',
            delete_content: 'Você tem certeza que quer remover este item?',
            delete_title: 'Remover %{name} #%{id}',
            details: 'Detalhes',
            error:
                'Ocorreu um erro no navegador e seu requisição não foi completada.',
            invalid_form:
                'O formulário não é válido. Por favor, verifique os erros',
            loading: 'A página está carregando, aguarde um momento',
            no: 'Não',
            not_found: 'Você digitou uma URL errada, ou não tem permissão para acessar essa página',
            yes: 'Sim',
            unsaved_changes:
                'Algumas de suas alteracões não foram salvas. Você tem certeza que quer ignorá-las?',
        },
        navigation: {
            clear_filters: 'Limpar filtros',
            no_filtered_results: 'Nenhum resultado encontrado',
            no_results: 'Nenhum resultado encontrado',
            no_more_results:
                'A página número %{page} fora dos limites. Tente a página anterior.',
            page_out_of_boundaries: 'A página %{page} está fora dos limites',
            page_out_from_end: 'Fim da paginação',
            page_out_from_begin: 'A página não pode ser menor que 1',
            page_range_info: '%{offsetBegin}-%{offsetEnd} de %{total}',
            partial_page_range_info:
                '%{offsetBegin}-%{offsetEnd} de mais de %{offsetEnd}',
            current_page: 'Página %{page}',
            page: 'Ir para página %{page}',
            first: 'Ir para a primeira página',
            last: 'Ir para a última página',
            next: 'Próxima',
            prev: 'Anterior',
            previous: 'Ir para página anterior',
            page_rows_per_page: 'Linhas por página:',
            skip_nav: 'Pular para conteúdo',
        },
        sort: {
            sort_by: 'Ordenar por %{field} %{order}',
            ASC: 'ascendente',
            DESC: 'descendente',
        },
        auth: {
            email: 'E-mail',
            auth_check_error: 'Faça o login para continuar',
            user_menu: 'Perfil',
            username: 'Usuário',
            password: 'Senha',
            new_password: 'Nova senha',
            confirm_password: 'Confirme a senha',
            sign_in: 'Entrar',
            sign_in_error: 'Erro na autenticação, por favor tente novamente',
            logout: 'Sair',
        },
        notification: {
            updated: 'Elemento atualizado |||| %{smart_count} elementos atualizados',
            created: 'Elemento criado',
            deleted:
                'Elemento removido |||| %{smart_count} elementos removidos',
            bad_item: 'Elemento incorreto',
            item_doesnt_exist: 'O elemento não existe',
            http_error: 'Erro de comunicação com o servidor',
            data_provider_error:
                'Erro com o servidor. Procure o suporte para esse problema.',
            i18n_error:
                'Não foi possível carregar as traduções para a linguagem especificada',
            canceled: 'Ação cancelada',
            logged_out: 'Sua sessão foi finalizada, por favor reconecte.',
            not_authorized: "Você não tem autorização para acessar esse recurso.",
            application_update_available: 'Uma nova versão está disponível.',
            offline: 'Sem conexão. Não foi possível carregar os dados.',
        },
        validation: {
            required: 'Obrigatório',
            minLength: 'Deve ter pelo menos %{min} caracteres',
            maxLength: 'Deve ter no máximo %{max} caracteres',
            minValue: 'Deve ser no mínimo %{min}',
            maxValue: 'Deve ser no máximo %{max}',
            number: 'Deve ser um número',
            email: 'Deve ser um e-mail válido',
            oneOf: 'Deve ser um destes: %{options}',
            regex: 'Deve respeiter um formato específico (regexp): %{pattern}',
            unique: 'Deve ser único',
        },
        saved_queries: {
            label: 'Filtros salvos',
            query_name: 'Nome do Filtro',
            new_label: 'Salvar como Filtro...',
            new_dialog_title: 'Salvar Filtro como',
            remove_label: 'Remover Filtro',
            remove_label_with_name: 'Remover Filtro "%{name}"',
            remove_dialog_title: 'Remover Filtro salvo?',
            remove_message:
                'Tem certeza que deseja remover esse filtro salvo?',
            help: 'Filtrar e salvar esse Filtro',
        },
        configurable: {
            customize: 'Customizar',
            configureMode: 'Configurar esta página',
            inspector: {
                title: 'Inspector',
                content: 'Passe o mouse por cima dos items para configurar',
                reset: 'Restaurar Configurações',
                hideAll: 'Esconder Todos',
                showAll: 'Mostrar Todos',
            },
            Datagrid: {
                title: 'Lista',
                unlabeled: 'Coluna sem nome #%{column}',
            },
            SimpleForm: {
                title: 'Formulário',
                unlabeled: 'Campo sem nome #%{input}',
            },
            SimpleList: {
                title: 'Lista',
                primaryText: 'Texto primário',
                secondaryText: 'Texto secundário',
                tertiaryText: 'Texto terciário',
            }
        }
    },
    tooltips: {
        presetUsingValue: 'Se ativado, o preset do abastecimento (ao encher tanque) será feito por valor (padrão R$ 9.999,00) em vez de por volume (padrão 999,99 litros).',
        generateCashbackOnFillin: 'Permite a geração de um cupom de cashback no abastecimento, de acordo com o fator cadastrado em "Produtos -> Cashback de abastecimento".',
        pointsWhenDiscounting: 'Permite conceder pontos mesmo quando o usuário utiliza um desconto no abastecimento. Quando desativado, os pontos só serão gerados se o abastecimento for feito sem uso de desconto.',
        usePendingTransaction: 'Solicita aprovação sempre que um abastecimento for realizado manualmente ou pela API. Quando o abastecimento não for automatizado pela bomba, ele ficará pendente de aprovação manual antes de ser validado.',
        useChronologyCouponInvoice: 'Garante que, a cada lançamento de cupom, o código do cupom fiscal informado seja maior que o anterior. Quando desativado, não há validação de ordem entre os cupons.',
        useOnlyRedeemAfterFillin: 'Exige um abastecimento para resgatar cupons, mesmo que o usuário tenha pontos. A regra se aplica a cada novo resgate.',
        useDateConcentrator: 'Usa a data do concentrador como referência nos abastecimentos, em vez da data de recebimento no sistema. Afeta relatórios, dashboards e demais análises.',
        showCashbackAtHome: 'Mostra na tela inicial o valor em cashback calculado a partir do saldo disponível. Quando desativado, apenas os pontos são exibidos.',
        appForceNotificationPermission: 'Força a permissão de notificações push no aplicativo. Quando desativado, o usuário poderá optar por não receber notificações. Quando ativada, o usuário sempre receberá um pedido pra ativar as notificações.',
        requireRatingOnFillin: 'Quando ativado, o usuário será obrigado a avaliar o abastecimento imediatamente após o término. Ele precisará completar essa avaliação para poder avançar para a próxima tela do aplicativo.',
        shouldShowStationRating: 'Exibe a média das notas que o posto recebeu de outros clientes na tela de informações do posto. Quando desativado, essa avaliação não será exibida para os usuários.',
        discountButtonEnabled: 'Ativa automaticamente o melhor desconto disponível para o usuário sempre que um novo abastecimento for iniciado. Quando desativado, o usuário deverá selecionar o desconto manualmente.',
        allowPromoterUnlinking: 'Permite que o cliente referenciado por um promoter possa se desvincular do vínculo com ele. Quando desativado, a associação com o promoter é permanente.',
        isOffersEnabledInCoupon: 'Permite exibir na tela de ofertas os descontos disponíveis para resgate com pontos, junto aos cupons já resgatados pelo usuário. Quando desativado, a tela mostra apenas os cupons resgatados anteriormente.',
        isEvoActive: 'Se ativado, o resgate deste produto será feito via integração com o módulo EVO.',
        productPlaceIsSanvitron: 'Se ativado, o resgate deste produto será feito via integração com a Sanvitron.',
        showFillinMsgPerLiterDiscount: 'Se ativada, mostra a mensagem de desconto obtido por litro no detalhamento do abastecimento.',
        showFillinMsgPoints: 'Se ativada, mostra a mensagem de pontuação obtida no detalhamento do abastecimento.',
        showFillinMsgCashback: 'Se ativada, mostra a mensagem de cashback equivalente no detalhamento do abastecimento.',
        useGeneratedDefaultPassword: 'Quando ativado, clientes vindos de sistemas externos, como o AutoSystem, terão uma senha padrão cadastrada automaticamente com os 6 primeiros dígitos do CPF durante a sincronização.',
        useVehicleOdometer: 'Ativa o registro de odômetro no fluxo de abastecimento. Quando ativo, o app solicita a quilometragem do veículo durante o abastecimento, exibe o menu "Meus Veículos" no perfil e mostra o odômetro nos detalhes do abastecimento.',
        raffleRegulationUrl: 'Define a URL onde os usuários poderão consultar o regulamento do sorteio relacionado ao Número da Sorte.',
        maxDevicePerCpf: 'Limita em quantos dispositivos diferentes um CPF pode fazer login. Se deixado em branco, não haverá restrição.',
        maxCpfPerDevice: 'Limita quantos CPFs diferentes podem fazer login em um mesmo dispositivo. Se deixado em branco, não haverá restrição.',
        showPricesInApp: 'Permite exibir o preço do combustível em telas como a de ofertas. Em vez de mostrar apenas o valor do desconto, será exibido o menor preço possível por litro, calculado com base no preço cadastrado menos o maior desconto disponível em cada posto da rede.',
        priceVisibleGroupIds: 'Os preços dos combustíveis serão exibidos apenas para os grupos de usuários selecionados. Se deixado em branco, todos os usuários poderão visualizar os preços no app.',
        productIsCombo: 'Se ativado, o parceiro aplicará o desconto em todos os produtos do carrinho do cliente. Se desativado, aplicará o desconto em apenas um dos produtos, caso estejam no carrinho.',
        useSanvitronIntegration: 'Se ativado, o posto/parceiro poderá criar produtos que tenha integração com equipamentos da Sanvitron',
        productCustomerTags: 'Defina para quais etiquetas de clientes este produto estará disponível.',
        hiddenProductIds: 'Oculta produtos específicos quando este for exibido. Útil para gerenciar produtos similares ou com diferentes condições de desconto.',
        defaultTagSGA: 'Essa etiqueta será aplicada para todos os Clientes que estão ativos na SGA',
        appStoreReviewEnabled: 'Quando habilitado, solicita ao usuário que avalie o aplicativo nas lojas (App Store/Play Store) após finalizar um abastecimento. O popup só aparece se: o dispositivo suportar in-app review, tiver passado 30 dias desde o último review, o usuário tiver feito pelo menos 3 abastecimentos desde o último, e o review ainda não tiver sido solicitado 3 vezes.',
        appAutoExpandDiscountModal: 'Quando habilitado, o modal de descontos abre já expandido mostrando todos os descontos disponíveis. Quando desabilitado, o modal abre com botões "Ver ofertas" e "Pular", permitindo que o usuário escolha se quer ver os descontos.',
    },
};

export default ptBr;
